<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          :color="color"
          :dark="dark"
          large
          :text="text"
          v-bind="attrs"
          v-on="on"
        >
          <span class="d-flex d-sm-none">{{ mobileButtonText }}</span>
          <span class="d-none d-sm-flex">{{ buttonText }}</span>
        </v-btn>
      </template>

      <v-card>
        <v-tabs
          v-model="tab"
          background-color="#0274b3"
          centered
          dark
          icons-and-text
        >
          <v-tab v-for="item in items" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in items" :key="item.tab">
            <v-card flat>
              <v-card-text>
                <component
                  v-bind:is="item.content"
                  :handleClose="handleClose"
                ></component>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <v-btn color="blue darken-1" text @click="dialog = false">
            Save
          </v-btn>
        </v-card-actions> -->
        <v-img
          src="https://hrng-assets.s3.amazonaws.com/five_person_group_pic_28770037e5.jpg"
          contain
        />
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Login from '@/components/Auth/Login';
import Register from '@/components/Auth/Register';
export default {
  data: () => ({
    dialog: false,
    tab: null,

    items: [
      { tab: 'Login', content: 'Login' },
      { tab: 'Register', content: 'Register' },
    ],
  }),
  components: { Login, Register },
  methods: {
    handleClose() {
      this.dialog = false;
    },
  },
  props: ['buttonText', 'color', 'dark', 'text', 'mobileButtonText'],
};
</script>
